enum BOOKS {
	BOOKS = '/api/library/books',
	BOOKS_BY_BARCODE = '/api/library/books/barcode/',
	BOOKS_BY_ID = '/api/library/books/',
	BOOKS_BY_IDS = '/api/library/books/'
}

enum ISSUANCES {
	ISSUE_BOOK = '/api/library/books/issue',
	RETURN_BOOK = '/api/library/books/return',
	ISSUANCES = '/api/library/issuances',
	OVERDUE_ISSUANCES = '/api/library/issuances/overdue'
}

enum ROOMS {
	ROOMS = '/api/library/rooms',
	ROOMS_BY_ID = '/api/library/rooms/',
	ROOMS_BY_IDS = '/api/library/rooms/',
	ROOM_AVAILABILITY_BY_ID = '/api/library/rooms/'
}

enum ROOM_BOOKINGS {
	BOOK_ROOM_BY_ID = '/api/library/rooms/',
	ROOM_BOOKINGS = '/api/library/rooms/bookings/',
	ROOM_BOOKINGS_BY_ID = '/api/library/rooms/bookings/',
	ROOM_BOOKING_LOGS = '/api/library/rooms/booking-logs'
}

enum PACKAGES {
	PACKAGES = '/api/library/packages',
	PACKAGES_BY_ID = '/api/library/packages/',
	PACKAGES_BY_IDS = '/api/library/packages/',
	PACKAGE_ITEMS_BY_ID = '/api/library/packages/',
	ISSUE_PACKAGE_BOOKS = '/api/library/packages/issue'
}

enum EBOOKS {
	EBOOKS_ACCESS_LOGS = '/api/library/ebooks/access-logs',
	EBOOK_READ = '/api/library/ebooks/'
}

enum PRINTING {
	PRINTING = '/api/library/printing',
	PRINT_BALANCE_BY_STUDENT_ID = '/api/library/printing/balance/',
	PRINTING_XLSX = '/api/library/printing/export/xlsx'
}

export default {
	BOOKS,
	ISSUANCES,
	ROOMS,
	ROOM_BOOKINGS,
	PACKAGES,
	EBOOKS,
	PRINTING
};
